module.exports = __webpack_public_path__ + "html/sign-up-block_cb1be651ec84fe0eb6a2999b580d66d2.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/sign-up-block.html
// module id = m5k6
// module chunks = 31